import React, { useCallback } from "react";
import {
  Dialog,
  HStack,
  Portal,
  Text,
  VStack,
  Image,
  Box,
} from "@chakra-ui/react";
import { Color } from "../styles/enums";
import { Button, ButtonVariant } from "../ui/button";

import novelButton from "../../assets/novel_selector.png";
import chatButton from "../../assets/chat_selector.png";

interface Props {
  open: boolean;
  onClose(): void;
  onNovelClicked(): void;
  onChatClicked(): void;
}

export const StoryTypeModal: React.FC<Props> = ({
  open,
  onClose,
  onNovelClicked,
  onChatClicked,
}) => {
  const toStudio = useCallback(() => {
    onChatClicked();
  }, [onChatClicked]);

  const toNovelStudio = useCallback(() => {
    onNovelClicked();
  }, [onNovelClicked]);

  return (
    <Dialog.Root
      open={open}
      onOpenChange={(details) => {
        if (!details.open) {
          onClose();
        }
      }}
      placement="center"
    >
      <Portal>
        <Dialog.Backdrop bg="rgba(0, 0, 0, 0.70)" />
        <Dialog.Positioner>
          <Dialog.Content
            mx="24px"
            py="40px"
            px="24px"
            bg="backgroundPrimary"
            maxW="336px"
            borderRadius={8}
          >
            <VStack w="100%" gap="24px">
              <Text fontSize="16px" fontWeight="bold" textAlign="center">
                どちらのスタジオを開きますか？
              </Text>
              <HStack w="100%" gap="22px">
                <Box flex={1} cursor="pointer" onClick={toNovelStudio}>
                  <Image src={novelButton} />
                </Box>
                <Box flex={1} cursor="pointer" onClick={toStudio}>
                  <Image src={chatButton} />
                </Box>
              </HStack>

              <Button
                type="submit"
                variant={ButtonVariant.OUTLINED}
                color={Color.ACCENT_1000}
                block
                big
                onClick={onClose}
              >
                閉じる
              </Button>
            </VStack>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
